import 'url-search-params-polyfill';
import jump from 'jump.js';

const elements = {
  accordion: document.body.querySelectorAll('.js-accordion'),
  accordionTrigger: document.body.querySelectorAll('.js-accordion-trigger'),
};

function calcIndex(index, keyCode) {
  const calc = {
    38: index - 1,
    40: index + 1,
  };

  return calc[keyCode];
}

function keyHandler(e) {
  const accordion = this.closest('.js-accordion');

  if (accordion !== null) {
    const index = parseInt(this.dataset.index, 10);

    if (
      (e.keyCode === 38 && index > 0) ||
      (e.keyCode === 40 && index < parseInt(accordion.dataset.count - 1, 10))
    ) {
      e.preventDefault();
      accordion.querySelectorAll('.js-accordion-trigger')[calcIndex(index, e.keyCode)].focus();
    }
  }
}

function getSiblings(elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  for (; sibling; sibling = sibling.nextSibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
  }
  return siblings;
}

function matchAttr(trimTerm) {
  const firstMatchingElement =
    document.body.querySelector(`.js-accordion-trigger[data-search='${trimTerm}'`) ||
    document.body.querySelector(`.js-accordion-trigger[id='${trimTerm}']`);

  if (firstMatchingElement) {
    const elParent = firstMatchingElement.parentNode;
    jump(elParent, {
      a11y: true,
      duration: 1200,
      offset: 0,
    });
    firstMatchingElement.click();
  }
}

function toggleVisibility() {
  const panelDiv = document.getElementById(this.getAttribute('aria-controls'));
  const prop = 'hidden';
  const active = 'is-active';
  const accordion = this.closest('.js-accordion');
  const parent = this.closest('.js-accordion-item');
  const parentSiblings = getSiblings(parent);

  parentSiblings.forEach((parentSibling) => {
    const siblingTrigger = parentSibling.querySelector('.is-active');
    if (!siblingTrigger) {
      return;
    }

    const triggerTarget = document.getElementById(siblingTrigger.getAttribute('aria-controls'));
    triggerTarget[prop] = !triggerTarget[prop];
    siblingTrigger.classList.remove(active);
    parentSibling.classList.remove(active);
    siblingTrigger.setAttribute('aria-expanded', 'false');
  });

  this.classList.toggle(active);
  parent.classList.toggle(active);
  panelDiv[prop] = !panelDiv[prop];

  if (this.getAttribute('aria-expanded') === 'false') {
    this.setAttribute('aria-expanded', 'true');
    accordion.classList.add(active);
  } else {
    this.setAttribute('aria-expanded', 'false');
    accordion.classList.remove(active);
  }
}

function init() {
  if (elements.accordion.length && elements.accordionTrigger.length) {
    for (let i = 0; i < elements.accordionTrigger.length; i += 1) {
      elements.accordionTrigger[i].removeAttribute('disabled');
      elements.accordionTrigger[i].removeAttribute('title');
      elements.accordionTrigger[i].addEventListener('click', toggleVisibility);
      elements.accordionTrigger[i].addEventListener('keydown', keyHandler);
    }

    // Jump to and open accordion if #id or ?search= in URL
    const urlSearchParams = new URLSearchParams(window.location.search);
    const urlId = window.location.hash.substring(1);
    const searchTerm = urlSearchParams.get('search');
    if (searchTerm) {
      matchAttr(searchTerm.replace(/\s+/g, '').toLowerCase());
    } else if (urlId) {
      matchAttr(urlId);
    }
  }
}

export default init;
